import React from 'react';
import BenchmarkDashboard from '../components/benchmark/BenchmarkDashboard';

const BenchmarkPage: React.FC = () => {
  return (
    <div className="benchmark-page">
      <BenchmarkDashboard />
    </div>
  );
};

export default BenchmarkPage;
